export function makeOfferShareUrl(appUrl: string, offerUri: string, offerId?: number | null): string {
  const url = new URL(offerUri, appUrl);

  if (offerId != null) {
    url.searchParams.set('offer_id', String(offerId));
  } else {
    url.searchParams.delete('offer_id');
  }

  return url.toString();
}

export function makeSocialShareUrl(serviceUrl: string, sharedUrl: string): string {
  const url = new URL(serviceUrl);

  url.searchParams.set('url', sharedUrl);

  return url.toString();
}
